/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as IndexRouteImport } from './app/index'
import { Route as ProductIndexRouteImport } from './app/product/index'
import { Route as SupportIndexRouteImport } from './app/support/index'
import { Route as SupportSlugIndexRouteImport } from './app/support/$slug/index'
import { Route as SupportSuccessIndexRouteImport } from './app/support/success/index'
import { Route as TermEulaIndexRouteImport } from './app/term/eula/index'
import { Route as TermInterceptor_privacy_policyIndexRouteImport } from './app/term/interceptor_privacy_policy/index'
import { Route as TermPrivacy_policyIndexRouteImport } from './app/term/privacy_policy/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductIndexRoute = ProductIndexRouteImport.update({
  id: '/product/',
  path: '/product/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSlugIndexRoute = SupportSlugIndexRouteImport.update({
  id: '/support/$slug/',
  path: '/support/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSuccessIndexRoute = SupportSuccessIndexRouteImport.update({
  id: '/support/success/',
  path: '/support/success/',
  getParentRoute: () => rootRouteImport,
} as any)
const TermEulaIndexRoute = TermEulaIndexRouteImport.update({
  id: '/term/eula/',
  path: '/term/eula/',
  getParentRoute: () => rootRouteImport,
} as any)
const TermInterceptor_privacy_policyIndexRoute =
  TermInterceptor_privacy_policyIndexRouteImport.update({
    id: '/term/interceptor_privacy_policy/',
    path: '/term/interceptor_privacy_policy/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TermPrivacy_policyIndexRoute = TermPrivacy_policyIndexRouteImport.update({
  id: '/term/privacy_policy/',
  path: '/term/privacy_policy/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/product/': typeof ProductIndexRoute
  '/support/': typeof SupportIndexRoute
  '/support/$slug/': typeof SupportSlugIndexRoute
  '/support/success/': typeof SupportSuccessIndexRoute
  '/term/eula/': typeof TermEulaIndexRoute
  '/term/interceptor_privacy_policy/': typeof TermInterceptor_privacy_policyIndexRoute
  '/term/privacy_policy/': typeof TermPrivacy_policyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/product': typeof ProductIndexRoute
  '/support': typeof SupportIndexRoute
  '/support/$slug': typeof SupportSlugIndexRoute
  '/support/success': typeof SupportSuccessIndexRoute
  '/term/eula': typeof TermEulaIndexRoute
  '/term/interceptor_privacy_policy': typeof TermInterceptor_privacy_policyIndexRoute
  '/term/privacy_policy': typeof TermPrivacy_policyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/product/': typeof ProductIndexRoute
  '/support/': typeof SupportIndexRoute
  '/support/$slug/': typeof SupportSlugIndexRoute
  '/support/success/': typeof SupportSuccessIndexRoute
  '/term/eula/': typeof TermEulaIndexRoute
  '/term/interceptor_privacy_policy/': typeof TermInterceptor_privacy_policyIndexRoute
  '/term/privacy_policy/': typeof TermPrivacy_policyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/product/'
    | '/support/'
    | '/support/$slug/'
    | '/support/success/'
    | '/term/eula/'
    | '/term/interceptor_privacy_policy/'
    | '/term/privacy_policy/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/product'
    | '/support'
    | '/support/$slug'
    | '/support/success'
    | '/term/eula'
    | '/term/interceptor_privacy_policy'
    | '/term/privacy_policy'
  id:
    | '__root__'
    | '/'
    | '/product/'
    | '/support/'
    | '/support/$slug/'
    | '/support/success/'
    | '/term/eula/'
    | '/term/interceptor_privacy_policy/'
    | '/term/privacy_policy/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProductIndexRoute: typeof ProductIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
  SupportSlugIndexRoute: typeof SupportSlugIndexRoute
  SupportSuccessIndexRoute: typeof SupportSuccessIndexRoute
  TermEulaIndexRoute: typeof TermEulaIndexRoute
  TermInterceptor_privacy_policyIndexRoute: typeof TermInterceptor_privacy_policyIndexRoute
  TermPrivacy_policyIndexRoute: typeof TermPrivacy_policyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/': {
      id: '/product/'
      path: '/product'
      fullPath: '/product/'
      preLoaderRoute: typeof ProductIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/$slug/': {
      id: '/support/$slug/'
      path: '/support/$slug'
      fullPath: '/support/$slug/'
      preLoaderRoute: typeof SupportSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/success/': {
      id: '/support/success/'
      path: '/support/success'
      fullPath: '/support/success/'
      preLoaderRoute: typeof SupportSuccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/term/eula/': {
      id: '/term/eula/'
      path: '/term/eula'
      fullPath: '/term/eula/'
      preLoaderRoute: typeof TermEulaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/term/interceptor_privacy_policy/': {
      id: '/term/interceptor_privacy_policy/'
      path: '/term/interceptor_privacy_policy'
      fullPath: '/term/interceptor_privacy_policy/'
      preLoaderRoute: typeof TermInterceptor_privacy_policyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/term/privacy_policy/': {
      id: '/term/privacy_policy/'
      path: '/term/privacy_policy'
      fullPath: '/term/privacy_policy/'
      preLoaderRoute: typeof TermPrivacy_policyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProductIndexRoute: ProductIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
  SupportSlugIndexRoute: SupportSlugIndexRoute,
  SupportSuccessIndexRoute: SupportSuccessIndexRoute,
  TermEulaIndexRoute: TermEulaIndexRoute,
  TermInterceptor_privacy_policyIndexRoute:
    TermInterceptor_privacy_policyIndexRoute,
  TermPrivacy_policyIndexRoute: TermPrivacy_policyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
